import React, { Component } from 'react';
import { formatarReal } from '../../util/numberUtil';
import Moment from 'react-moment';

export default class ReciboCupomBagagem extends Component {

    linha() {
        return <hr style={{ borderStyle: 'dashed', borderWidth: 3 }} />
    }

    exibirLimiteCupom() {
        return <div className='printer-element'>--</div>
    }

    exibirFormasPagamento() {
      if(!this.props.bagagem)
        return ''
      return this.props.bagagem.formasPagamento.map((it, index) => <React.Fragment key={`formas-pagamento-${index}`}>
          <tr>
              <td colSpan="3">Forma de pagamento:</td>
          </tr>
          <tr>
              <td colSpan="3">{it.tipo}: {formatarReal(it.valor.toString())}</td>
          </tr>
          <tr>
             <td colSpan="3">Parcelas: {it.quantidadeParcelas ? it.quantidadeParcelas: '1'} X</td>
          </tr>
      </React.Fragment>)

      }


    exibirCupom(via, passageiro) {
        const { bagagem, empresaSelecionada } = this.props;
        return (
            <div>
                {this.exibirLimiteCupom()}
                <table className="printer-ticket">
                    <thead>
                        {this.exibirCabecalho(via, passageiro, empresaSelecionada?.nome, empresaSelecionada?.cnpj)}
                    </thead>
                    <tbody>
                        <tr>
                            <td colSpan="3"><strong>Nº Reserva:</strong> {bagagem.reservaId}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Identificador:</strong> {bagagem.codigoRastreio}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Passageiro:</strong> {bagagem.nomePassageiro}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Vendedor:</strong> {bagagem.nomeVendedor}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Tipo de cálculo:</strong> {bagagem.descTipoCalculoBagagem}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Data emissão:</strong>
                            <Moment format="DD/MM/YYYY">{bagagem.dataHoraRegistro}</Moment></td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Valor:</strong> {bagagem.valor?.toLocaleString('pt-BR', {
                                                                                                  style: 'currency',
                                                                                                  currency: 'BRL',
                                                                                                }) || 'R$ 0,00'}</td>
                        </tr>
                        <tr>
                            <td colSpan="3"><strong>Peso:</strong> {bagagem.peso} kg</td>
                        </tr>
                         {this.exibirFormasPagamento()}
                        <tr>
                            <td colSpan="3">&nbsp;&nbsp;</td>
                        </tr>

                        <tr style={{ textAlign: 'center' }}>
                            <td className="title" colSpan="3">
                                OS número: {bagagem.reservaId}
                            </td>
                        </tr>

                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan="3" align='center'>
                                <span className="text-break" style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                    Observação: {!bagagem.observacao? 'Inclusão de bagagem extra' : bagagem.observacao}
                                </span>
                            </td>
                        </tr>
                    </tfoot>
                </table>
                {this.exibirLimiteCupom()}
            </div>
        )
    }

    exibirCabecalho(label, pessoa, nomeEmpresa, cnpj) {
        const { bagagem } = this.props;
        return (
            <>
                <tr>
                    <th className="title" colSpan="3">
                        {nomeEmpresa}
                        <br />
                        <strong>CNPJ:</strong> {cnpj}
                    </th>
                </tr>
                <tr>
                    <th colSpan="3">{bagagem.dataCriacao}</th>
                </tr>
                <tr>
                    <td colSpan="3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                </tr>
                {!bagagem.ativa?
                    <tr style={{ textAlign: 'center' }}>
                        <td className='title' colSpan="3">
                            ***** CANCELADA ******
                        </td>
                    </tr>
                 :''}
                <tr style={{ textAlign: 'center' }}>
                    <td colSpan="3">
                        {pessoa?.nome || bagagem.nomePassageiro}
                        <br />
                        {pessoa?.cpfCnpj}
                    </td>
                </tr>
                <tr style={{ textAlign: 'center' }}>
                    <td className='title' colSpan="3">
                        Via {label}
                    </td>
                </tr>
            </>
        )
    }

    render() {
        return (
            <div>
                <div ref={this.props.referencias ? this.props.referencias.get('PASSAGEIRO').referencia : null}>
                    {this.exibirCupom('Passageiro', this.props.bagagem)}

                </div>

                <div ref={this.props.referencias ? this.props.referencias.get('EMPRESA').referencia : null}>
                    <div className="pagebreak"></div>
                    {this.exibirCupom('Empresa', this.props.empresaSelecionada)}
                </div>
            </div>
        )
    }
}


